const PLAYER_VENDOR_PATTERN = /(?:tcplayer|dplayer)/i
const EXPECTED_MEDIA_ERROR_TYPES = new Set([
  'AbortError',
  'NotAllowedError',
  'NotSupportedError',
])
const VERIFIED_PLAYER_ERROR_PATTERNS = [
  /Cannot read properties of null \(reading 'vdata\d+'\)/,
  /null is not an object \(evaluating 'localStorage\.(?:getItem|setItem)'\)/,
  /Failed to execute '(?:start|end)' on 'TimeRanges'/,
]

function getExceptionValues(event) {
  return Array.isArray(event?.exception?.values) ? event.exception.values : []
}

function collectEventText(event, hint) {
  const parts = [event?.message, event?.title, event?.culprit]
  getExceptionValues(event).forEach((value) => {
    parts.push(value?.type, value?.value)
    value?.stacktrace?.frames?.forEach((frame) => {
      parts.push(frame?.filename, frame?.function)
    })
  })
  const original = hint?.originalException
  if (original) {
    parts.push(original.name, original.message, original.stack, String(original))
  }
  return parts.filter(Boolean).join('\n')
}

function isAxiosCancellation(event, hint) {
  const original = hint?.originalException
  if (original?.code === 'ERR_CANCELED') return true

  const values = getExceptionValues(event)
  return values.some(
    (value) =>
      ['AxiosError', 'CanceledError'].includes(value?.type) &&
      ['Request aborted', 'canceled'].includes(value?.value)
  )
}

function isVerifiedPlayerNoise(event, hint) {
  const text = collectEventText(event, hint)
  if (!PLAYER_VENDOR_PATTERN.test(text)) return false

  const hasExpectedMediaError = getExceptionValues(event).some((value) =>
    EXPECTED_MEDIA_ERROR_TYPES.has(value?.type)
  )
  if (hasExpectedMediaError) return true
  return VERIFIED_PLAYER_ERROR_PATTERNS.some((pattern) => pattern.test(text))
}

function appendAxiosErrorContext(event, hint) {
  const axios = hint?.originalException?.__sentry_extra__?.axios
  if (!axios) return event

  event.extra = { ...event.extra, axios }
  event.contexts = { ...event.contexts, axios }
  event.tags = {
    ...event.tags,
    axios_method: axios['axios.request.method'],
    axios_status: axios['axios.response.status'] || 'no_response',
    axios_has_response: String(axios['axios.hasResponse']),
  }
  return event
}

export function processSentryEvent(event, hint) {
  if (isAxiosCancellation(event, hint)) return null
  if (isVerifiedPlayerNoise(event, hint)) return null
  return appendAxiosErrorContext(event, hint)
}
